import {connect} from 'react-redux';
import ConfirmDialog from 'shared/ConfirmDialog.jsx';
import {setRemoveVirtualEntryConfirmationVisibility} from '../shared/actionTypes';
import {
  handleRemoveUnassignedVirtualEntries
} from '../shared/actions';

const mapStateToProps = state => ({
  visible: state.registration.shared.removeVirtualEntryConfirmationVisible,
  title: 'Confirm',
  content: `This will remove the ${state.registration.shared.virtualEntryToRemove.quantity} unassigned ${state.registration.shared.virtualEntryToRemove.name} entries. Are you sure you want to do this?`,
  cancelBtnLabel: 'Cancel',
  confirmBtnLabel: 'Save'
});

const mapDispatchToProps = dispatch => ({
  onCancelClick: () => dispatch(setRemoveVirtualEntryConfirmationVisibility(false)),
  onCloseClick: () => dispatch(setRemoveVirtualEntryConfirmationVisibility(false)),
  onConfirmClick: () => dispatch(handleRemoveUnassignedVirtualEntries())
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog);



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/RemoveVirtualEntriesConfirmationModalContainer.jsx